import { StyleSheet } from 'react-native';
import { tokens } from '../../../../constants';
import { getProgressColor } from '../../ProgressStyles';
export var getLinearProgressTypography = size => {
  var sizes = {
    sm: {
      start: 'body-single-line-xs-bold',
      end: 'body-single-line-xs-bold',
      hint: 'body-para-xs'
    },
    md: {
      start: 'body-single-line-xs-bold',
      end: 'body-single-line-xs-bold',
      hint: 'body-para-xs'
    },
    lg: {
      start: 'body-single-line-sm-bold',
      end: 'body-single-line-sm-bold',
      hint: 'body-para-sm'
    }
  };
  return sizes[size];
};
export var getLinearProgressStyles = props => {
  var _a, _b, _c;
  var size = props.size,
    _props$value = props.value,
    value = _props$value === void 0 ? 0 : _props$value,
    progressBackgroundColor = props.progressBackgroundColor,
    config = props.config;
  var progressColor = getProgressColor(props);
  return StyleSheet.create({
    barContainer: {
      position: 'relative',
      height: (_c = (_b = (_a = config === null || config === void 0 ? void 0 : config.size) === null || _a === void 0 ? void 0 : _a[size]) === null || _b === void 0 ? void 0 : _b.linear) === null || _c === void 0 ? void 0 : _c.thickness,
      backgroundColor: progressBackgroundColor,
      width: '100%',
      borderRadius: tokens.borderRadius.BORDER_RADIUS_8,
      overflow: 'hidden'
    },
    bar: Object.assign(Object.assign({}, StyleSheet.absoluteFillObject), {
      height: '100%',
      width: value + "%",
      backgroundColor: progressColor,
      overflow: 'hidden',
      borderRadius: tokens.borderRadius.BORDER_RADIUS_8
    }),
    startEndContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: tokens.spacing.SPACING_4
    },
    startText: {
      marginRight: tokens.spacing.SPACING_8
    },
    hintText: {
      marginTop: tokens.spacing.SPACING_4
    }
  });
};